import React, { useEffect, useState } from "react";
import "./pages.css";
import {
  useForgotPasswordMutation,
  useLoginMutation,
  useRefreshTokenMutation
} from "../store/api/authApi";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { login, logout } from "../store/slice/authSlice";
import { jwtDecode } from "jwt-decode";
import { useDispatch } from "react-redux";
import Button from "../components/Button";

export function LoginForm() {
  const location = useLocation();
  const email1 = location.state?.email || "";
  const [email, setEmail] = useState(email1);
  const [password, setPassword] = useState("");
  const [errors, setErrors] = useState({ email: "", password: "" });
  const [showPassword, setShowPassword] = useState(false);
  const [loginUser] = useLoginMutation();
  const [forgotPass] = useForgotPasswordMutation();
  const [refreshToken] = useRefreshTokenMutation();
  const [loadingLogin, setLoadingLogin] = useState(false); // NEW
  const [loadingForgot, setLoadingForgot] = useState(false); // NEW

  const navigate = useNavigate();
  const dispatch = useDispatch();

  useEffect(() => {
    const checkAuth = async () => {
      const accessToken = localStorage.getItem("accessToken");
      const refresh = localStorage.getItem("refreshToken");

      if (!accessToken) {
        dispatch(logout());
        return;
      }

      try {
        if (accessToken) {
          dispatch(logout());
          return
        }
        const decoded = jwtDecode(accessToken ?? "");

        const now = Date.now() / 1000;

        if (decoded.exp < now) {
          if (refresh) {
            try {
              const response = await refreshToken({ refreshToken: refresh }).unwrap();
              localStorage.setItem("accessToken", response.accessToken);
              localStorage.setItem("refreshToken", response.refreshToken);
              dispatch(login());
            } catch (err) {
              localStorage.removeItem("accessToken");
              localStorage.removeItem("refreshToken");
              dispatch(logout());
            }
          } else {
            dispatch(logout());
          }
        } else {
          dispatch(login());
        }
      } catch (err) {
        console.error("Ошибка проверки токена:", err);
        dispatch(logout());
      }
    };

    checkAuth();
  }, [dispatch, refreshToken]);

  const handleLogin = async () => {
    if (errors.email || errors.password || !email || !password) return;

    try {
      setLoadingLogin(true); // NEW
      const response = await loginUser({ email, password }).unwrap();
      if (response.success) {
        localStorage.setItem("accessToken", response.accessToken);
        localStorage.setItem("refreshToken", response.refreshToken);
        dispatch(login({ token: response.accessToken }));
        navigate("/orders");
      } else {
        setErrors({ email: "Неверный email или пароль", password: "Неверный email или пароль" });
      }
    } catch (err) {
      setErrors({ ...errors, email: "Ошибка входа" });
      console.error("Ошибка входа:", err);
    } finally {
      setLoadingLogin(false); // NEW
    }
  };

  const handleForgotPassword = async () => {
    if (!email) return;
    try {
      setLoadingForgot(true); // NEW
      const { data } = await forgotPass({ email });
      if (data.success) {
        navigate("/confirm-code", { state: { email, isResetPassword: true } });
      }
    } catch (err) {
      console.error("Ошибка запроса восстановления:", err);
    } finally {
      setLoadingForgot(false); // NEW
    }
  };

  const handleEmailChange = (e) => {
    const value = e.target.value;
    setEmail(value);
    if (!value) {
      setErrors((prev) => ({ ...prev, email: "Email обязателен" }));
    } else if (!/\S+@\S+\.\S+/.test(value)) {
      setErrors((prev) => ({ ...prev, email: "Неправильный формат email" }));
    } else {
      setErrors((prev) => ({ ...prev, email: "" }));
    }
  };

  const handlePasswordChange = (e) => {
    const value = e.target.value;
    setPassword(value);
    if (!value) {
      setErrors((prev) => ({ ...prev, password: "Пароль обязателен" }));
    } else if (value.length <= 2) {
      setErrors((prev) => ({ ...prev, password: "Минимум 2 символов" }));
    } else {
      setErrors((prev) => ({ ...prev, password: "" }));
    }
  };

  return (
    <div className="login">
      <div className="login-left">
        <div className="login_form">
          <div className="login-form_top"></div>
          <div className="login-form_title">Авторизация</div>
          <div className={`login-form_field ${errors.email ? "err_field" : ""}`}>
            <div className="login-form_label">email</div>
            <input
              className="login-form_inp"
              type="email"
              placeholder="Email"
              value={email}
              onChange={handleEmailChange}
              required
            />
          </div>
          {errors.email ? <p className="err_text">{errors.email}</p> : <p> </p>}

          <div className={`login-form_field ${errors.password ? "err_field" : ""}`}>
            <div className="login-form_label">password</div>
            <input
              className="login-form_inp"
              type={showPassword ? "text" : "password"}
              placeholder="Пароль"
              value={password}
              onChange={handlePasswordChange}
              required
            />
            <img src="" alt="" className="login-form_img" />
          </div>
          {errors.password && <p className="err_text">{errors.password}</p>}

          <div className="login-form_bottom">
            <Button onClick={handleLogin} disabled={loadingLogin}>
              {loadingLogin ? "Входим..." : "Войти"}
            </Button>

            <div className="login-form_bottom_text">
              <p> У вас ещё нет аккаунта? </p>{" "}
              <Link to={"/register"} className="register">
                Зарегистрироваться
              </Link>
            </div>

            {!!email && (
              <div
                className="login-form_bottom_text"
                onClick={handleForgotPassword}
                style={{ pointerEvents: loadingForgot ? "none" : "auto", opacity: loadingForgot ? 0.6 : 1 }}
              >
                <li className="register">{loadingForgot ? "Отправляем..." : "Забыли пароль?"}</li>
              </div>
            )}
          </div>
        </div>
      </div>
      <div className="login-img">
        <img src="/new-logo.jpg" alt="" />
      </div>
    </div>
  );
}

export default LoginForm;
